import axios from "axios";
import { UserSession } from "../user_session";
import * as Vars from "./Vars";

export class Buckets {

  static async load(id){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/bucket/",
        method: "GET",
        params: {
          _console_token: UserSession.token,
          id: id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  static async get(project_id, bucket_id){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/bucket/",
        method: "GET",
        params: {
          _console_token: UserSession.token,
          id: project_id,
          bucket_id: bucket_id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  static async create(project_id, name){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/bucket/",
        method: "POST",
        data: {
          _console_token: UserSession.token,
          project: project_id,
          name: name
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  static async edit(bucket_id, name) {
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/bucket/",
        method: "PUT",
        data: {
          _console_token: UserSession.token,
          id: bucket_id,
          name: name
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  static async delete(bucket_id) {
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/bucket/",
        method: "DELETE",
        data: {
          _console_token: UserSession.token,
          id: bucket_id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }
}
